export default __webpack_public_path__ + "assets/images/1134eda80e532b0169d255c8755e66ca.jpg";